import React, {  useState, useCallback, useEffect, useRef } from "react";
import { toast } from "react-toastify";

import Loading from "~/components/layout/Loading";
import api from '~/services/api';
import useOutsideClickDropdown from "~/hooks/useOutsideClickDropdown";
import {  usePendency } from '~/hooks/pendency'

import {
  ModalContent,
  Container,
  Header,
  Main,
  Footer,
  Title,
  Button,
  Attachment,
  CloseIcon,
  Alert,
  InputFile,
  ButtonSuspense,
  Background,
  LoadingIcon
} from "./styles";

export default function ModalContracts() {
  const { pendencySelected, handlePendency } = usePendency()
  const modalRef = useRef(null)
  const [files, setFiles] = useState([])
  const [messageErrorSubmit, setMessageErrorSubmit] = useState('')
  const [comment, setComment] = useState('')
  const [isShow, setIsShow] = useState(false)
  const [isResolved, setIsResolved] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const handleCloseModal = useCallback(() => {
    setIsShow(false)
  },[setIsShow])

  useOutsideClickDropdown(modalRef, handleCloseModal);

  useEffect(() => {
    setFiles([])
    setMessageErrorSubmit('')
    setComment('')
    setIsResolved(false)
    setIsSubmit(false)
    if(pendencySelected){
      setIsShow(true)
    }
  },[pendencySelected])

  useEffect(() => {
    if(!isShow){
      setTimeout(() => handlePendency(isResolved),700)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isShow])

  const handleRemoveFile = useCallback((key) => {
    setFiles(sta => sta.filter(element => element.key !== key ))
  }, [setFiles])

  const handleBytesToSize = useCallback((bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const index = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    const rest = Math.round(bytes % Math.pow(1024, index), 2)
    let weightFile = Math.round(bytes / Math.pow(1024, index), 2)
    weightFile = rest > 0 ? weightFile + 1 : weightFile
    const sizeFormatted = weightFile + ' ' + sizes[index]
    const aboveTheLimit = weightFile > 15 && index >= 2 ? true : false
    return {sizeFormatted, aboveTheLimit}
  }, [])

  const handleFiles = useCallback((event) => {
    const file = event.target.files[0]
    const format = handleBytesToSize(file.size)
    const item = { key: files.length, file, ...format }
    setFiles(files.concat(item))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setFiles, files])

  const convertFileToBase64 = useCallback(async(file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result)
      };

      fileReader.onerror = (error) => {
        reject(error)
      }
    })
  }, [])

  const prepareFileSubmit = useCallback(async (item) => {
    const body =  await convertFileToBase64(item)
    const format = item.name
      .slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2)
      .toUpperCase()
    const name =  item.name.substring(0, item.name.lastIndexOf("."))
    return {
      name,
      format,
      body: body.slice((body.indexOf(",") - 1 >>> 0) + 2),
    }
  }, [convertFileToBase64])

  const handlePatchRequest = useCallback(async ({data, parameters, type}) => {
    try{
      await api.patch(`/industrial/case/v1/cases-sf/${pendencySelected.id}`, data, parameters)
      if(type === 'phase') {
        setIsResolved(true)
        toast.success("Justificativa enviada com sucesso!")
        handleCloseModal()
      }
    }catch{
      toast.error('erro ao enviar')
      setIsSubmit(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, toast, pendencySelected, handleCloseModal,setIsResolved])

  const handleUpdatePendency = useCallback(async (type, item = null) => {
    if(!comment && type ==='comment') return;
    const options = {
      attachment : {
        attachment : type === 'attachment' && await prepareFileSubmit(item),
      },
      comment : {
        comment : comment,
      },
      phase : {
        phase : "AGUARDANDO_ANALISE_DO_ADMINISTRATIVO",
      },
    }

    const parameters = {
      headers: {
        method: "PATCH",
        access_token: localStorage.getItem("access_token"),
      },
    };
   const data = options[type]
   await handlePatchRequest({data, parameters, type})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comment, handlePatchRequest])

  const handleSubmit = useCallback(async (event) => {
    event.preventDefault()
    setIsSubmit(true)
    setMessageErrorSubmit('')
    const unexpectedFileSize = files.find(item => item.aboveTheLimit)

    if(files.length < 1){
      setMessageErrorSubmit('Você deve enviar pelo menos um arquivo')
      setIsSubmit(false)
      return;
    }
    if(!!unexpectedFileSize){
      setMessageErrorSubmit('O tamanho máximo permitido para arquivos anexos é de 15MB.')
      setIsSubmit(false)
      return;
    }
    if(files.length > 5){
      setIsSubmit(false)
      return;
    }

    files.forEach(async (element) => {
      await handleUpdatePendency( 'attachment', element.file)
    })
    await handleUpdatePendency('comment')
    await handleUpdatePendency('phase')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files, pendencySelected, api, comment,setIsSubmit])

  return (
    <Background isShow={isShow} >
      <Container isShow={isShow}>
      <ButtonSuspense onClick={handleCloseModal}>
          <CloseIcon
            title="Fechar"
            className="mdi mdi-close"
          />
        </ButtonSuspense>
      <ModalContent ref={modalRef} isShow={isShow}>

        {
          !pendencySelected
          ? <Loading margin="100% auto" />
          : (

              <form onSubmit={handleSubmit}>
                <Header>
                  <Title>Detalhes da Pendência</Title>
                  <div>
                    <Title>{pendencySelected.number}</Title>
                  </div>
                </Header>

                <Main>
                  <p>
                    Você possui uma pendência: {pendencySelected.description}
                    {messageErrorSubmit && (
                      <Alert>
                        {messageErrorSubmit}
                      </Alert>
                    )}
                  </p>
                  {files.length < 5 && (
                    <aside>
                      <InputFile>
                        Anexar arquivo
                        <input
                          type="file"
                          onChange={handleFiles}
                          //accept=".jpg, .jpeg, .png, .pdf, .xls, .doc"
                        />
                      </InputFile>
                     {/* <Button>
                        <CameraIcon
                          title="Photo"
                          className="mdi mdi-camera"
                        />
                     </Button>*/}
                    </aside>
                  )}

                  {files.map((item) => (
                    <>
                      <Attachment key={item.key} overweight={item.aboveTheLimit}>
                        <div>
                          <span>{item.file.name}</span>
                          <span>({item.sizeFormatted})</span>
                        </div>
                        <button
                          onClick={() => handleRemoveFile(item.key)}
                        >
                          <CloseIcon
                            title="Fechar"
                            className="mdi mdi-close"
                          />
                        </button>
                      </Attachment>
                      {item.aboveTheLimit && (
                        <Alert ml>
                          O tamanho máximo permitido para arquivos anexos é de 15MB.
                        </Alert>
                      )}
                    </>
                  ))}
                  <textarea
                    maxLength="255"
                    placeholder="Comentário..."
                    onChange={(event) => setComment(event.target.value)}
                    value={comment}
                  />
                  {comment.length >= 255 && (
                    <Alert ml>
                      Limite de 255 caracteres atingido.
                    </Alert>
                  )}
                </Main>

                <Footer>
                  <Button type='submit' disabled={isSubmit}>
                    {isSubmit
                      ?  <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                      : 'Enviar'
                    }
                  </Button>
                </Footer>
              </form>
          )
        }
      </ModalContent>
      </Container>
    </Background>
  );
}
